import { FC, useState } from "react";
import { Button, Spinner, Text } from "@radix-ui/themes";
import { useNavigate } from "react-router";
import { siteRoutes } from "@/routes/siteRoutesList";
import { createQuickAccountUser } from "@/utils/sharedHelperFunctions";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import i18next from "i18next";

export const SignUpAnonymously: FC<{}> = ({}) => {
  const navigate = useNavigate();
  const [loading, isLoading] = useState<boolean>(false);
  const setProfile = useCurrentUserProfile((s) => s.setUser);

  const handleLogInAnonymously = async () => {
    isLoading(true);
    await createQuickAccountUser(setProfile).finally(async () => {
      navigate(siteRoutes["profile"]);
    });
    isLoading(false);
  };

  return (
    <Button
      style={{ width: "100%" }}
      variant="solid"
      size="3"
      onClick={async () => {
        await handleLogInAnonymously();
      }}
    >
      <Text size="2">
        {loading ? <Spinner /> : i18next.t("auth.input.button.quick_account")}
      </Text>
    </Button>
  );
};
